// extracted by mini-css-extract-plugin
export default {"custombutton":"styles_custombutton__p6vmV","custombutton__light":"styles_custombutton__light__qGyue","custombutton__dark":"styles_custombutton__dark__A15lB"};